<template>
  <div class="main-page">
    <Menus title="军人军属法律援助绿色通道" />
    <div class="container-flex">
      <div class="content">
        <div class="titles">
          申请须知
        </div>
        <div class="notice-content">

          <div v-html="detail"></div>
        </div>
        <router-link v-if="detail" to="/legalaid/applyInfo?type=military" class="button">
          知道了
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { MILITARY_FAMILY_LEGAL_APPLY } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  data () {
    return {
      detail: ''
    }
  },
  mounted () {
    this.$root.getStatistics(MILITARY_FAMILY_LEGAL_APPLY)
    this.getData()
  },
  methods: {
    async getData () {
      const result = await this.$api.getPfPost({ post_id: '69c4ed287edc0136a8f17de6' })
      this.detail = result.data.content

    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 13rem
  margin 0.2rem auto 0.6rem
  padding 0.5rem 0.7rem 0.6rem 0.7rem
  border-radius 0.3rem
  background rgba(255, 255, 255, 0.2)
  color #fff
  box-shadow 0 0.1rem 0.25rem rgba(0, 0, 0, 0.05)
  .titles
    text-align center
    font-size 0.34rem
    line-height 0.3rem
    padding-bottom 0.3rem
    letter-spacing 1px
  .notice-content
    font-size 0.24rem
    line-height 2
    /deep/ h2
      font-size 0.28rem
      margin 0.15rem 0
    /deep/ p
      margin 1em 0
  .button
    display block
    margin 0.6rem auto 0 auto
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background-color #fc9d0b
    border-radius 0.1rem
    font-size 0.28rem
</style>
